











import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class UiBadgeComponent extends Vue {
  @Prop({
    default: null
  })
  public schema: string|null;

  @Prop({
    default: null
  })
  public imageUri: string|null;

  @Prop()
  public title: string;

  @Prop({
    default: false
  })
  public titleId: string|false;

  @Prop()
  public subtitle: string;

  @Prop({
    default: ''
  })
  public size: string;

  @Prop({
    default: false
  })
  public iconOnly: boolean;

  public get iconClass(): 'with-image'|null {
    if (this.inactive) {
      return null;
    }

    return 'with-image';
  }

  public get iconStyle(): { backgroundImage: string; }|null {
    if (this.inactive) {
      return null;
    }

    return { backgroundImage: `url(${this.imageUri})` };
  }

  private get inactive(): boolean {
    return this.schema === 'inactive';
  }
}
